import { render, staticRenderFns } from "./ComplianceUnlockModal.vue?vue&type=template&id=638389f5&"
import script from "./ComplianceUnlockModal.vue?vue&type=script&lang=js&"
export * from "./ComplianceUnlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports